import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { galleryItems } from '../data/gallery';
import { copy } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
export function GalleryGrid() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const {
    t
  } = useLanguage();
  const active = activeIndex === null ? null : galleryItems[activeIndex];
  useEffect(() => {
    if (activeIndex === null) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setActiveIndex(null);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [activeIndex]);
  return <>
      <ul className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4" data-id="element-188" data-mp="2vxzg26d7wdaa">
        {galleryItems.map((item, index) => <li key={item.src + item.label.en} className={item.span ? 'col-span-2 row-span-2' : ''} data-id="element-189" data-mp="2qyd37y1awz20" data-mpi={index}>
            <button type="button" onClick={() => setActiveIndex(index)} className="group relative block h-full w-full overflow-hidden rounded-lg bg-navy-900 text-left" data-id="element-190" data-mp="345xg43zplhn9">
              <img src={item.src} alt={t(item.caption)} loading="lazy" className={`w-full object-cover transition-transform duration-300 ease-smooth group-hover:scale-105 ${item.span ? 'h-full min-h-[220px]' : 'aspect-[4/3]'}`} data-id="element-191" data-mp="3iv3mcbwys84n" />
              <span className="pointer-events-none absolute inset-x-0 bottom-0 bg-navy-950/75 px-3 py-2 text-xs font-bold uppercase tracking-wide text-gold-300 sm:text-sm" data-id="element-192" data-mp="2v4fyuiakf9wz">
                {t(item.label)}
              </span>
            </button>
          </li>)}
      </ul>

      <AnimatePresence data-id="element-193" data-mp="egc4aboq74oi">
        {active && <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-navy-950/90 p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} role="dialog" aria-modal="true" aria-label={t(active.caption)} onClick={() => setActiveIndex(null)} data-id="element-194" data-mp="ef28xu99calk">
            <motion.figure initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.98
        }} transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} className="max-h-full w-full max-w-4xl overflow-hidden rounded-xl bg-navy-900" onClick={event => event.stopPropagation()} data-id="element-195" data-mp="1rsqvybhkae9w">
              <img src={active.src} alt={t(active.caption)} className="max-h-[70vh] w-full object-contain" data-id="element-196" data-mp="191py5qs6gorx" />
              <figcaption className="flex items-start justify-between gap-4 p-5" data-id="element-197" data-mp="3fqrmtmlodzth">
                <span data-id="element-198" data-mp="3khzvuhj3fj64">
                  <span className="block text-xs font-bold uppercase tracking-wide text-gold-300" data-id="element-199" data-mp="3ki9m8681vscc">
                    {t(active.label)}
                  </span>
                  <span className="mt-1 block text-navy-200" data-id="element-200" data-mp="36os4mqyxcpoy">
                    {t(active.caption)}
                  </span>
                </span>
                <button type="button" onClick={() => setActiveIndex(null)} aria-label={t(copy.galleryHome.close)} className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-navy-700 text-white transition-colors duration-150 ease-smooth hover:bg-navy-800" data-id="element-201" data-mp="3axtfrjw8l7h">
                  <XIcon width={20} height={20} aria-hidden="true" data-id="element-202" data-mp="2e1ebl3yckea4" />
                </button>
              </figcaption>
            </motion.figure>
          </motion.div>}
      </AnimatePresence>
    </>;
}